import React from 'react';
import classnames from 'clsx';

import style from './style.module.less';

/**
 * Tag types enum
 * @readonly
 * @enum {string}
 */
export const TagType = {
  Neutral: 'neutral',
  Success: 'success',
  Warning: 'warning',
  Alert: 'alert',
  Info: 'info',
  ReadOnly: 'readonly',
  Error: 'error',
};

/**
 * @typedef {import('react-intl').FormattedMessage} FormattedMessage
 */

/**
 * Tag component props
 * @typedef {object} TagProps
 * @property {string|React.ReactElement<FormattedMessage>} message - The message to display in the tag
 * @property {TagType} [type=TagType.Neutral] - The type of tag
 * @property {string} [className=null] - Additional class name for the tag container
 * @property {string} [wrapperClassname=''] - Additional class name for the tag wrapper
 * @property {boolean} [showStatusDot=true] - Whether to display the status dot indicator
 * @property {string} [amplitudeTrackingId] - Renders as `data-amplitude-id` for Amplitude Guide/Survey CSS-selector targeting
 */

/**
 * Tag component for displaying status indicators
 * @deprecated Use `Tag` from `@shipstation/client-common/components/tag` instead.
 * See: ui-components/readme-documentation/MIGRATION.md
 * @param {TagProps} props - The component props
 * @returns {React.ReactElement} The rendered Tag component
 */
export const Tag = ({
  message,
  type = TagType.Neutral,
  className = null,
  wrapperClassname = '',
  showStatusDot = true,
  amplitudeTrackingId,
}) => {
  return (
    <div className={classnames(className, style[type])} data-amplitude-id={amplitudeTrackingId} data-testid='tag-container'>
      <div className={classnames(style['status-tag-wrapper'], wrapperClassname)} data-testid='tag-wrapper'>
        {showStatusDot ? <div className={style['status-dot']} /> : null}
        <div className={style['status-text']}>{message}</div>
      </div>
    </div>
  );
};
